module.exports = __webpack_public_path__ + "img/etoile_off.fbc61d75.gif";